import ReportRow from "./ReportRow";

function ReportCard({ title, data, months = [], onHide, isTrialBalance = false }) {
  if (!data) return <p>Loading...</p>;
  if (!Array.isArray(data) || data.length === 0)
    return <div className="report-card">No data available</div>;

  const sortedMonths = months.slice().sort();

  return (
    <div className="report-card">
      <h1 className="report-title">{title}</h1>

      {/* Loop through each top-level company */}
      {data.map((company, idx) => (
        <div key={idx} className="company-block">
          <h3 className="company-title">{company.name}</h3>

          <div
            className={`report-table-container ${
              months.length === 12 ? "full-year-table" : ""
            }`}
          >
            <table className="report-table">
              <thead>
                <tr>
                  <th>{isTrialBalance ? "Account" : "Name"}</th>

                  {isTrialBalance ? (
                    <>
                      <th>Debit</th>
                      <th>Credit</th>
                    </>
                  ) : (
                    <>
                      {(sortedMonths.length > 0 ? sortedMonths : ["Amount"]).map((month) => (
                        <th key={month}>{month}</th>
                      ))}

                      {sortedMonths.length > 1 && <th>Total</th>}
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* Each company’s children render as hierarchical sections */}
                {company.children?.map((child, cIdx) => (
                  <ReportRow
                    key={`${company.name}-${cIdx}`}
                    item={child}
                    months={sortedMonths}
                    onHide={onHide}
                    isTrialBalance={isTrialBalance}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <div className="report-footer">
        {new Date().toLocaleString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
          timeZoneName: "short",
        })}
      </div>
    </div>
  );
}

export default ReportCard;
